import {
    createRateField,
    createRateFieldValidation,
    rateValidationSchemaSuperRefine as validationSchemaSuperRefine,
} from 'constants/FormField/createRateField'
import useFromFieldWithAccount from 'logic/useFromFieldWithAccount'

const useRates = () => {
    const {fieldsCreate, fieldsEdit, isLoading, validationSchema} = useFromFieldWithAccount({
        fieldsCreate: createRateField,
        fieldsEdit: createRateField,
        validationSchema: createRateFieldValidation,
        accountIsOptional: true,
        validationSchemaSuperRefine,
    })

    return {
        fieldsCreate,
        fieldsEdit,
        isLoading,
        validationSchema,
    }
}

export default useRates
